import { useNavigate } from 'react-router-dom';
import { FairdayLogo } from '../components/Brand/FairdayLogo';

export const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="fixed top-[37px] left-0 right-0 px-6 py-4 flex justify-between items-center z-40 bg-gradient-to-b from-brand-surface to-transparent">
      <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
        <FairdayLogo className="h-[60px] w-auto" color="white" />
      </div>
      <div className="flex items-center gap-4">
        <button
          className="px-4 py-1.5 text-sm font-medium text-text-muted hover:text-neutral-light transition-colors"
          onClick={() => navigate('/signin')}
        >
          Sign In
        </button>
      </div>
    </header>
  );
}
